import { useEffect, useState } from 'react';

import { getAdminAccounts, switchAccount, AdminAccount } from 'api/auth';
import { getToken, setToken } from 'helpers/localStorage';

const isAdminToken = (): boolean => {
  try {
    const token = getToken();
    if (!token) return false;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.is_admin === true;
  } catch {
    return false;
  }
};

const AccountSwitcher = () => {
  const [accounts, setAccounts] = useState<AdminAccount[]>([]);
  const [current, setCurrent] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const admin = isAdminToken();

  useEffect(() => {
    if (!admin) return;
    getAdminAccounts()
      .then((data) => {
        setAccounts(data.accounts);
        setCurrent(String(data.current_account_id));
      })
      .catch(() => {});
  }, [admin]);

  if (!admin || accounts.length === 0) return null;

  const onChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value;
    if (next === current) return;
    setLoading(true);
    try {
      const { token } = await switchAccount(Number(next));
      setToken(token);
      window.location.href = '/';
    } catch {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 mb-6">
      <p className="uppercase text-xs text-axll-dark-grey font-medium tracking-wide mb-2">
        Account
      </p>
      <select
        value={current}
        onChange={onChange}
        disabled={loading}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm bg-white focus:outline-none"
      >
        {accounts.map((a) => (
          <option key={a.id} value={a.id}>
            {a.account_name} ({a.id})
          </option>
        ))}
      </select>
    </div>
  );
};

export default AccountSwitcher;
